
export default {
  props: {
    example: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    examples() {
      return this.example
        ? [this.$t('kit'), this.$t('multivalve'), this.$t('tank'), this.$t('filter')]
        : []
    }
  },
  methods: {
    focusInput() {
      this.$refs.search.focusInput()
    },
    onChange(value) {
      if (value) {
        const route = {
          name: 'products',
          query: {
            search: value
          }
        }

        this.$navigateTo(route)
      }
    }
  }
}
